import * as React from 'react';
import useKeyPress from './use-key-press.js';

const useIsOpenSuggestions = (inputRef)=>{
    const [isSuggestionsOpen, setIsSuggestionsOpen] = React.useState(false);
    const escPress = useKeyPress('Escape', inputRef);
    React.useEffect(()=>{
        setIsSuggestionsOpen(false);
    }, [
        escPress
    ]);
    return [
        isSuggestionsOpen,
        setIsSuggestionsOpen
    ];
};

export { useIsOpenSuggestions as default };
//# sourceMappingURL=use-is-open-suggestions.js.map
